import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  isOpen: boolean;
  interestedPlan: string | null;
}

const initialState: ModalState = {
  isOpen: false,
  interestedPlan: null,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<string | undefined>) => {
      state.isOpen = true;
      state.interestedPlan = action.payload ?? null;
    },
    closeModal: state => {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
